module.exports = __webpack_public_path__ + "assets/img/nav_bg2.61e8ce83.png";